import { ConfirmarSenhaProps } from "../../views/confirmarSenha/confirmarSenha";
import { ConfirmarSenhaRequest } from "../../types/confirmarSenha/confirmarSenhaRequest";

export default class ConfirmarSenhaContainer {
  public props: ConfirmarSenhaProps;

  constructor(props: ConfirmarSenhaProps) {
    this.props = props;
  }

  public validarSenhas(senha: string, confirmacaoSenha: string): boolean {
    return senha === confirmacaoSenha;
  }

  public async enviarNovaSenha(senha: string, confirmacaoSenha: string, token: string) {
    if (!this.validarSenhas(senha, confirmacaoSenha)) {
      return false;
    }

    const payload: ConfirmarSenhaRequest = {
      Senha: senha,
      Token: token
    };

    await this.props.ConfirmarNovaSenha(payload);
  }
}
